<template>
  <teleport to="body"><SessionExpiryAlert /></teleport>
  <section id="content"><router-view></router-view></section>
</template>

<script>
import { mapState } from "vuex";
import { AUTO_LOGIN_ACTION } from "./store/storeconstants";
import SessionExpiryAlert from "./views/modal/SessionExpiryAlert.vue";
export default {
  name: "App",
  components: { SessionExpiryAlert },
  computed: {
    ...mapState({
      autoLogout: (state) => state.auth.autoLogout,
    }),
  },
  watch: {
    autoLogout(curValue, oldValue) {
      if (curValue && curValue != oldValue) {
        this.$router.replace("/Login");
      }
    },
  },
  created() {
    this.$store.dispatch(`auth/${AUTO_LOGIN_ACTION}`);
  },
  mounted() {
    window.addEventListener("beforeunload", this._onBeforeUnload);
    this.init();
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this._onBeforeUnload);
  },
  methods: {
    init() {
      this.$router.replace("home");
    },
    _onBeforeUnload(e) {
      if (!this.$store.getters["ui/HAS_UNSAVED_CHANGES"]) return;
      e.preventDefault();
      e.returnValue = "";
    },
  },
};
</script>

<style></style>
